import { render, staticRenderFns } from "./ConfirmEmailModal.vue?vue&type=template&id=33e08f06&scoped=true&"
import script from "./ConfirmEmailModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e08f06",
  null
  
)

export default component.exports